import { SettingsDirtyStateProvider } from '../hooks/useSettingsDirtyState'
import { useSettingsPage } from '../hooks/useSettingsPage'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { DarkProvider } from '@hivewatch/dark'

import { DarkPageLayout } from '@/components/layouts/DarkPageLayout'
import { Head } from '@/components/layouts/Head'

import type { SettingsSectionRegistrations } from '../types/types'
import { SettingsShell } from './SettingsShell'
import { UnsavedChangesModal } from './UnsavedChangesModal'

interface DarkSettingsPageIProps {
  registrations?: SettingsSectionRegistrations
}

export const DarkSettingsPage = ({
  registrations = {},
}: DarkSettingsPageIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const {
    activeSection,
    discardAndContinue,
    isNavigationPending,
    keepEditing,
    registerDirtyState,
    saveAndContinue,
    sections,
    selectSection,
  } = useSettingsPage(registrations)

  return (
    <>
      <Head metaSubTitle={t('settings:rebrand_page_title')} />
      <DarkProvider colorScheme={colorScheme}>
        <SettingsDirtyStateProvider registerDirtyState={registerDirtyState}>
          <DarkPageLayout colorScheme={colorScheme}>
            <SettingsShell
              activeSection={activeSection}
              colorScheme={colorScheme}
              onSelectSection={selectSection}
              sections={sections}
            />
            <UnsavedChangesModal
              colorScheme={colorScheme}
              isOpen={isNavigationPending}
              isSaving={activeSection.dirtyState?.status === 'saving'}
              onDiscard={discardAndContinue}
              onKeepEditing={keepEditing}
              onSave={() => void saveAndContinue()}
            />
          </DarkPageLayout>
        </SettingsDirtyStateProvider>
      </DarkProvider>
    </>
  )
}
